
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { toast } from '@/hooks/use-toast';

const PaymentCallback = () => {
  const [processing, setProcessing] = useState(true);
  const [status, setStatus] = useState<'success' | 'failure' | null>(null);
  const location = useLocation();

  useEffect(() => {
    const processPayment = async () => {
      try {
        // Получаем параметры из URL
        const searchParams = new URLSearchParams(location.search);

        // Здесь будет логика обработки платежа на основе полученных параметров
        // Например, проверка статуса платежа, параметров подписи и т.д.

        // Симуляция обработки ответа от платежной системы
        setTimeout(() => {
          console.log('Обработка параметров платежа:', Object.fromEntries(searchParams.entries()));

          // После обработки переадресуем на соответствующую страницу
          if (searchParams.get('status') === 'success') {
            setStatus('success');
            window.location.href = '/payment-success';
          } else {
            setStatus('failure');
            window.location.href = '/payment-fail';
          }

          setProcessing(false);
        }, 2000);
      } catch (error) {
        console.error('Ошибка при обработке платежа:', error);
        toast({
          title: "Ошибка обработки платежа",
          description: "Возникла проблема при обработке данных платежа.",
          variant: "destructive"
        });
        setStatus('failure');
        setProcessing(false);
        // Переадресуем на страницу с ошибкой
        setTimeout(() => {
          window.location.href = '/payment-fail';
        }, 1000);
      }
    };

    processPayment();
  }, [location]);

  return (
    <div className="min-h-screen bg-wax-50 pt-24 pb-16 px-4">
      <div className="container mx-auto max-w-3xl">
        <Card className="bg-white shadow-lg rounded-2xl">
          <CardContent className="p-8 flex flex-col items-center justify-center">
            {processing && (
              <>
                <Loader2 className="h-12 w-12 text-honey-500 animate-spin mb-4" />
                <h1 className="font-cormorant-garamond text-2xl font-medium mb-2">Обработка платежа</h1>
                <p className="text-gray-600">
                  Пожалуйста, не закрывайте эту страницу. Мы обрабатываем данные вашего платежа.
                </p>
              </>
            )}

            {!processing && status === 'success' && (
              <p>Перенаправление на страницу успешного платежа...</p>
            )}

            {!processing && status === 'failure' && (
              <p>Перенаправление на страницу с информацией об ошибке...</p>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCallback;
